import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Item as ItemType } from '../types';
import { GripHorizontal } from 'lucide-react';

interface ItemProps {
  item: ItemType;
  tierId: string | null;
}

export const Item: React.FC<ItemProps> = ({ item, tierId }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: item.id,
    data: {
      tierId,
      type: 'item',
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : undefined,
    position: 'relative' as const,
    zIndex: isDragging ? 999 : undefined,
    touchAction: 'none',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="bg-white dark:bg-gray-800 rounded-lg shadow-md cursor-move group hover:shadow-lg transition-shadow w-[160px] sm:w-[200px] touch-none"
    >
      {item.image && (
        <div className="w-full h-24 sm:h-32 rounded-t-lg overflow-hidden">
          <img
            src={item.image}
            alt={item.name}
            className="w-full h-full object-cover"
            draggable={false}
          />
        </div>
      )}
      <div className="p-2 sm:p-4">
        <div className="flex items-center gap-1 sm:gap-2">
          <GripHorizontal
            className="opacity-50 group-hover:opacity-100 transition-opacity text-gray-500 dark:text-gray-400 w-4 h-4 sm:w-5 sm:h-5"
          />
          <span className="font-medium text-gray-900 dark:text-white text-sm sm:text-base">{item.name}</span>
        </div>
      </div>
    </div>
  );
};